<!--
<!-- Modal -->
<!-- <div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-sm" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLongTitle">MODAL TITLE</h5>
                <button type="button" class="close"
                    data-dismiss="modal" aria-label="Close"
                    (click) = "CloseClick()">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">

            </div>
        </div>
    </div>
</div> -->


<button (click)="Test()"></button>

<div class="col-md-12">
  <div class="card" style="border-radius: 0.5rem">
    <div class="card-header">
      <div class="card-title">
        <h1 class="mb-5">
          Attendance Summary for the year of
          <div class="btn-group">
            <div class="dropdown">
              <h1 class="btn btn-outline-dark btn-sm dropdown-toggle" role="button" id="dropdownYear"
                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {{ year }}
              </h1>
              <div class="dropdown-menu" aria-labelledby="dropdownYear">
                <button *ngFor="let item2 of yearDropdown" class="dropdown-item" type="button"
                  (click)="UpdateYear(item2)">
                  {{ item2 }}
                </button>
              </div>
            </div>
          </div>
        </h1>
      </div>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <div class="container-fluid my-4">
            <div class="d-flex flex-wrap justify-content-between">
              <!-- <h1 class="mb-5">
                Attendance Summary for the year of
                <div class="btn-group">
                  <div class="dropdown">
                    <h1 class="btn btn-outline-dark btn-sm dropdown-toggle" role="button" id="dropdownYear"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      {{ year }}
                    </h1>
                    <div class="dropdown-menu" aria-labelledby="dropdownYear">
                      <button *ngFor="let item2 of yearDropdown" class="dropdown-item" type="button"
                        (click)="UpdateYear(item2)">
                        {{ item2 }}
                      </button>
                    </div>
                  </div>
                </div>
              </h1> -->
            </div>

            <div class="w-100 scroll">
              <table class="table table-striped table-sm table-hover mb-4">
                <thead class="thead-dark">
                  <tr>
                    <th class="wid-10-p text-center sticky-row first-row">
                      Month Name
                    </th>
                    <th class="wid-6pt4-p sticky-row first-row">
                      Casual BF
                    </th>
                    <th class="wid-6pt4-p sticky-row first-row">
                      Annual BF
                    </th>
                    <th class="wid-6pt4-p sticky-row first-row">
                      Casual Added
                    </th>
                    <th class="wid-6pt4-p sticky-row first-row">
                      Annual Added
                    </th>
                    <th class="wid-6pt4-p sticky-row first-row">
                      Casual Taken
                    </th>
                    <th class="wid-6pt4-p sticky-row first-row">
                      Annual Taken
                    </th>
                    <th class="wid-6pt4-p sticky-row first-row">
                      Off Days
                    </th>
                    <th class="wid-6pt4-p sticky-row first-row">
                      LWP
                    </th>
                    <th class="wid-6pt4-p sticky-row first-row">
                      NEL
                    </th>
                    <th class="wid-6pt4-p sticky-row first-row">
                      Casual CF
                    </th>
                    <th class="wid-6pt4-p sticky-row first-row">
                      Annual CF
                    </th>
                    <th class="wid-6pt4-p sticky-row first-row">
                      Lapsed
                    </th>
                    <th class="wid-6pt4-p sticky-row first-row">
                      Cashed
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let month of monthDropdown" class="text-right">

                    <td class="text-left">{{month.Text}}</td>

                    <td>
                      <div *ngIf="summaryList[month.Value-1]!=null; else elseBlock">
                        {{ summaryList[month.Value - 1].OldCasualBalance }}
                      </div>
                      <ng-template #elseBlock>
                        <i style="color:rgb(197, 197, 197)" class="fas fa-circle fa-xs"></i>
                      </ng-template>
                    </td>
                    <td>
                      <div *ngIf="summaryList[month.Value-1]!=null; else elseBlock">
                        {{ summaryList[month.Value - 1].OldAnnualBalance }}
                      </div>
                    </td>
                    <td>
                      <div *ngIf="summaryList[month.Value-1]!=null; else elseBlock">
                        {{ summaryList[month.Value - 1].CasualBalanceAdded }}
                      </div>
                    </td>
                    <td>
                      <div *ngIf="summaryList[month.Value-1]!=null; else elseBlock">
                        {{ summaryList[month.Value - 1].AnnualBalanceAdded }}
                      </div>
                    </td>
                    <td>
                      <div *ngIf="summaryList[month.Value-1]!=null; else elseBlock">
                        {{ summaryList[month.Value - 1].CasualLeaves }}
                      </div>
                    </td>
                    <td>
                      <div *ngIf="summaryList[month.Value-1]!=null; else elseBlock">
                        {{ summaryList[month.Value - 1].AnnualLeaves }}
                      </div>
                    </td>
                    <td>
                      <div *ngIf="summaryList[month.Value-1]!=null; else elseBlock">
                        {{ summaryList[month.Value - 1].OffDaysWorked }}
                      </div>
                    </td>
                    <td>
                      <div *ngIf="summaryList[month.Value-1]!=null; else elseBlock">
                        {{ summaryList[month.Value - 1].LWP }}
                      </div>
                    </td>
                    <td>
                      <div *ngIf="summaryList[month.Value-1]!=null; else elseBlock">
                        {{ summaryList[month.Value - 1].NotEnoughLeaves }}
                      </div>
                    </td>
                    <td>
                      <div *ngIf="summaryList[month.Value-1]!=null; else elseBlock">
                        {{ summaryList[month.Value - 1].NewCasualBalance }}
                      </div>
                    </td>
                    <td>
                      <div *ngIf="summaryList[month.Value-1]!=null; else elseBlock">
                        {{ summaryList[month.Value - 1].NewAnnualBalance }}
                      </div>
                    </td>
                    <td>
                      <div *ngIf="summaryList[month.Value-1]!=null; else elseBlock">
                        {{ summaryList[month.Value - 1].LeavesLapsed }}
                      </div>
                    </td>
                    <td>
                      <div *ngIf="summaryList[month.Value-1]!=null; else elseBlock">
                        {{ summaryList[month.Value - 1].LeavesCashed }}
                      </div>
                    </td>

                  </tr>
                </tbody>
              </table>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>
